import axios from "axios";
import { API_GATEWAY } from "../../utils/constants/api-constants";
import { axiosInterceptorHeaders } from "../interceptor/interceptors";

export const ColdexAPI = axios.create({
  baseURL: API_GATEWAY,
});

axiosInterceptorHeaders(ColdexAPI);
